import { error } from '../utils/utils.js';
export var argsToParams = function argsToParams(args) {
  var params = {};

  switch (typeof args[0]) {
    case 'object':
      Object.assign(params, args[0]);
      break;

    default:
      ['title', 'html', 'type'].forEach(function (name, index) {
        switch (typeof args[index]) {
          case 'string':
            params[name] = args[index];
            break;

          case 'undefined':
            break;

          default:
            error("Unexpected type of ".concat(name, "! Expected \"string\", got ").concat(typeof args[index]));
        }
      });
  }

  return params;
};